import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconUnblock = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.858 11.004L8.554 7.7L7.154 6.3L2.996 2.142L0.854 0L0 0.854L2.142 2.996C1.15966 4.20571 0.660523 5.73657 0.741018 7.29282C0.821513 8.84907 1.47593 10.3203 2.57783 11.4222C3.67974 12.5241 5.15093 13.1785 6.70718 13.259C8.26343 13.3395 9.79429 12.8403 11.004 11.858L13.146 14L14 13.146L11.858 11.004ZM3.5 7.7V6.3H5.446L6.846 7.7H3.5ZM7 0.7C5.9588 0.701711 4.93426 0.961454 4.018 1.456L8.862 6.3H10.5V7.7H10.262L12.544 9.982C13.0595 9.02262 13.3175 7.94599 13.2928 6.85716C13.2681 5.76833 12.9616 4.7045 12.4031 3.76948C11.8446 2.83446 11.0533 2.06018 10.1063 1.52222C9.15937 0.984249 8.08911 0.700962 7 0.7Z"
                fill={color}
            />
        </svg>
    </div>
);

export default IconUnblock;
